import React from 'react';

//components
import ThriveModal from './ThriveModal';
import BasicButton from '../buttons/BasicButton';

//interfaces
import { IButtonSelectModal, IButtonSelectModalItem } from '../../../interfaces/modals/ButtonSelectModal';



const ButtonSelectModal = ({className, title, buttonList, onCloseClick, footerContent}: IButtonSelectModal) => {
    
    return (
        <ThriveModal 
            showModal
            className={`button-select-modal ${className}`}
            headerContent={<h1 className='button-select-modal-header'>{title}</h1>} 
            bodyContent={
                <div className="button-select-modal-body">
                {buttonList && buttonList.length > 0 ? (
                    buttonList?.map((button: IButtonSelectModalItem, index: number) => (
                        <BasicButton
                            key={index}
                            className='button-select-modal-button'
                            content={button.text}
                            ariaLabel={button.label}
                            isDisabled={button.isDisabled}
                            onButtonClick={button.onButtonClick}
                        />
                        ))
                    ) : (
                        <p className='button-select-no-options'>No options available</p>
                    )
                }
                </div>
            } 
            footerContent={footerContent} 
            onCloseClick={onCloseClick}
        />
    );
};

export default ButtonSelectModal;